var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header-wrapper"},[_c('div',{staticClass:"avatar",style:({backgroundImage: ("url(" + _vm.src + ")")})}),_c('div',{staticClass:"nick"},[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }